import React from "react";
import { Button } from "main/components/ui-components/Button";
import capacityplanningslider from "../../../main/assets/images/Icons/HomePage - Icons/capacity-planning-slider.svg";
import jeopardyslider from "../../../main/assets/images/Icons/HomePage - Icons/jeopardy-management-slider.svg";
import operationalplanningslider from "../../../main/assets/images/Icons/HomePage - Icons/operational-planning-slider.svg";
import routemappingslider from "../../../main/assets/images/Icons/HomePage - Icons/route-mapping-slider.svg";
import scenarioplanningslider from "../../../main/assets/images/Icons/HomePage - Icons/scenario-modelling-slider.svg";
import strategicplanningslider from "../../../main/assets/images/Icons/HomePage - Icons/strategic-planning-slider.svg";
import capacityplanningsliderWhite from "../../../main/assets/images/Icons/HomePage - Icons/capacity-planning-slider-white.svg";
import jeopardysliderWhite from "../../../main/assets/images/Icons/HomePage - Icons/jeopardy-management-slider-white.svg";
import operationalplanningsliderWhite from "../../../main/assets/images/Icons/HomePage - Icons/operational-planning-slider-white.svg";
import routemappingsliderWhite from "../../../main/assets/images/Icons/HomePage - Icons/route-mapping-slider-white.svg";
import scenarioplanningsliderWhite from "../../../main/assets/images/Icons/HomePage - Icons/scenario-modelling-slider-white.svg";
import strategicplanningsliderWhite from "../../../main/assets/images/Icons/HomePage - Icons/strategic-planning-slider-white.svg";
import Cards from "main/components/ui-components/Card";
import { Link } from "react-router-dom";
import LandingPageBanner from "main/components/componentsHelper/Landgingpage/LandingPageBanner";
import LoadingPage2 from "main/components/componentsHelper/Landgingpage/LoadingPage2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
type Props = {};

const LandingPage = (props: Props) => {
  //const [activeindex, setActiveIndex] = useState(0);
  interface CARDDATA {
    path: string;
    title: string;
    txtmsg: string;
    className?: string;
    to?: any;
    whitesvg?: string;
  }
  /* const banners: any[] = [
    LandingPageBanner,
    LandingPageBanner,
    LandingPageBanner,
  ]; */

  const carddata: CARDDATA[] = [
    {
      path: capacityplanningslider,
      whitesvg: capacityplanningsliderWhite,
      title: "Capacity Planning",
      to: "/capacity-planning",
      txtmsg: "Unlock the power of forecasting.",
    },
    {
      path: strategicplanningslider,
      whitesvg: strategicplanningsliderWhite,
      title: "Strategic Planning",
      to: "/strategic-planning",
      txtmsg: "Forward planning of resources and demand.",
    },
    {
      path: operationalplanningslider,
      whitesvg: operationalplanningsliderWhite,
      title: "Operational Planning",
      to: "/operational-planning",
      txtmsg: "Laying the ground work for daily operations.",
    },
    {
      path: jeopardyslider,
      whitesvg: jeopardysliderWhite,
      title: "Jeopardy Management",
      to: "/jeopardy-management",
      txtmsg: "Empowering decisions with informed predictions.",
    },
    {
      path: routemappingslider,
      whitesvg: routemappingsliderWhite,
      title: "Route Mapping",
      to: "/route-mapping",
      txtmsg: "Charting the most optimized route for your operations.",
    },
    {
      path: scenarioplanningslider,
      whitesvg: scenarioplanningsliderWhite,
      title: "Scenario Modelling",
      to: "/scenario-modelling",
      txtmsg: "Navigating uncertainties with confidence.",
    },
  ];
  /*  const goToSlide = (index: number) => {
    setActiveIndex(index);
  }; */
  return (
    <div>
      <LandingPageBanner />
      <LoadingPage2 />
      {/* mobile View */}
      <div className="d-block d-md-none">
        <div className="overflow-hidden">
          <div className="container-fluid bg-color-n">
            <div className="d-flex justify-content-center flex-column align-items-center py-20">
              <div className="col md-3 text-center py-30">
                <h1 className="line-23 font-family-roboto align-items-center fonts-800 text-white-color font-20 wp-100 px-50 landing-heading-width pb-20">
                  The Future of Supply Chain Operations: Smart, Lean and Powered
                  by Yantr.ai
                </h1>
                <p className="fonts-400 wx-925 font-family-roboto font-13 line-20 landing-heading-width text-white-color pb-30 px-40">
                  Yantr.ai provides end-to-end visibility by bringing together
                  people, data, and technology for intelligent execution,
                  improving the customer experience while optimizing your supply
                  chain cost of operations.
                </p>
                <div className={`buttongroup d-flex justify-content-center`}>
                  <div className="">
                    <Link to={"/platform"}>
                      <Button
                        textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                        className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                        text="View All"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row bg-color-n py-50 hx-160"></div>
          <div className="row mt-n-150">
            <div className="col-md-12 overflow-scroll">
              <div className="d-flex justify-content-center flex-column flex-md-row flex-lg-row justify-content-around flex-gap-20 mb-40">
                <Swiper
                  slidesPerView={"auto"}
                  spaceBetween={0}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[Pagination]}
                  className="dashboard-swiper customSwiper"
                >
                  {carddata.map((val, index) => (
                    <SwiperSlide className="width-homepage">
                      <Link to={val.to} key={index}>
                        <Cards
                          classname="mobile-landing-cards landing-cards radius-5 benefits-view dark-header font-family-roboto font-20 fonts-800 line-35 pb-10 px-20"
                          title={val.title}
                          whiteIcon={val.whitesvg}
                          icon={val.path}
                          desc={val.txtmsg}
                        />
                      </Link>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Website */}
      <div className="d-none d-md-block">
        <div className="overflow-hidden">
          <div className="container-fluid bg-color-n">
            <div className="d-flex justify-content-center flex-column align-items-center py-20">
              <div className="col md-3 text-center py-30">
                <h1 className="line-35 font-family-roboto align-items-center fonts-800 text-white-color font-30 wp-100 px-40 landing-heading-width pb-20">
                  The Future of Supply Chain Operations: Smart, Lean and Powered
                  by Yantr.ai
                </h1>
                <p className="fonts-400 wx-925 font-family-roboto font-16 line-20 landing-heading-width text-white-color pb-30 p-auto m-auto w-60">
                  Yantr.ai provides end-to-end visibility by bringing together
                  people, data, and technology for intelligent execution,
                  improving the customer experience while optimizing your supply
                  chain cost of operations.
                </p>
                <div className={`buttongroup d-flex justify-content-center`}>
                  <div className="hp-18 radius-5 align-items-center justify-content-center common-btn text-color-success">
                    <Link to={"/platform"}>
                      <Button
                        textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                        className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                        text="View All"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row bg-color-n py-50 hx-160"></div>
          <div className="row mt-n-150">
            <div className="col-md-12 overflow-scroll">
              <div className="d-flex justify-content-center flex-column flex-md-row flex-lg-row justify-content-around flex-gap-20 mb-40">
                {carddata.map((val, index) => (
                  <Link to={val.to} key={index}>
                    <Cards
                      classname="mobile-landing-cards landing-cards radius-5 benefits-view dark-header font-family-roboto font-20 fonts-800 line-35 pb-10 px-20"
                      title={val.title}
                      whiteIcon={val.whitesvg}
                      icon={val.path}
                      desc={val.txtmsg}
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
